import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";

export const Manifesto = ({ section }) => {
  if (!section) return null;

  const chapters = section.metadata?.chapters || [];
  const stats = section.metadata?.stats || [];

  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-24 md:py-32 bg-[#050505]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <SectionLabel index={section.metadata?.section_index || "03"}>{section.eyebrow}</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-anton uppercase text-[#FAFAFA] text-5xl md:text-7xl lg:text-8xl leading-[0.88] mb-20 max-w-5xl">
            {section.title} <span className="text-stroke-gold">{section.title_accent}</span>
          </h2>
        </Reveal>

        <div className="flex flex-col">
          {chapters.map((chapter, index) => (
            <Reveal key={`${chapter.number}-${chapter.title}`} delay={index * 0.1}>
              <div
                data-testid={`manifesto-${chapter.number}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 border-t border-white/10 py-12 md:py-16"
              >
                <div className="md:col-span-3">
                  <span className="font-anton text-7xl md:text-8xl text-stroke group-hover:text-[#E85A24] transition-colors duration-500">
                    {chapter.number}
                  </span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-anton uppercase text-3xl md:text-4xl text-[#E85A24] leading-none">
                    {chapter.title}
                  </h3>
                </div>
                <div className="md:col-span-5">
                  <p className="font-dm text-lg md:text-xl text-[#A3A3A3] leading-relaxed">{chapter.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {stats.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10 mt-24"
          >
            {stats.map((stat) => (
              <div key={`${stat.value}-${stat.label}`} className="bg-[#050505] p-8 text-center">
                <p className="font-anton text-4xl md:text-6xl text-[#E85A24] leading-none">{stat.value}</p>
                <p className="font-oswald uppercase tracking-[0.2em] text-xs text-[#A3A3A3] mt-3">{stat.label}</p>
              </div>
            ))}
          </motion.div>
        )}
      </div>
    </section>
  );
};
